function filterSizes(button, selectedSystem) {
    const sizes = document.querySelectorAll('.size-item-for-system');
    sizes.forEach(function(size) {
      if (size.getAttribute('data-size-system') === selectedSystem) {
        size.classList.add('active');
      } else {
        size.classList.remove('active');
      }
    });

    // Indicate the active button
    const buttons = document.querySelectorAll('.size-system-button-container button');
    buttons.forEach(function(btn) {
      btn.classList.remove('active');
    });
    button.classList.add('active');
}

function toggleLocaleOptions(localeType) {
    const options = document.querySelectorAll('.popup-navigation__options-container-' + localeType)[0];
    options && options.classList.toggle('popup-navigation__expanded'); // Toggle sliding effect
}